import bpcActuals from './bpc-actuals.json'
import insights from './insights.json'
import kpiFormulas from './kpi-formulas.json'
import kpiLabels from './kpi-labels.json'
import notifications from './notifications.json'
import periodDataIssues from './period-data-issues.json'
import subChannels from './sub-channels.json'

export default {
  ...bpcActuals,
  ...insights,
  ...kpiFormulas,
  ...kpiLabels,
  ...notifications,
  ...periodDataIssues,
  ...subChannels,
}
